import { render, staticRenderFns } from "./TestAttempt.vue?vue&type=template&id=f4a2f22c&scoped=true&"
import script from "./TestAttempt.vue?vue&type=script&lang=js&"
export * from "./TestAttempt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4a2f22c",
  null
  
)

export default component.exports